module.exports = __webpack_public_path__ + "static/media/potato.1670a7f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/potato.svg
// module id = 260
// module chunks = 0